import { render, staticRenderFns } from "./blue-whatsapp.vue?vue&type=template&id=3e3deee8&scoped=true"
import script from "./blue-whatsapp.vue?vue&type=script&lang=js"
export * from "./blue-whatsapp.vue?vue&type=script&lang=js"
import style0 from "./blue-whatsapp.vue?vue&type=style&index=0&id=3e3deee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3deee8",
  null
  
)

export default component.exports